function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 446 640",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-352.165,-176.011)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.07952,0,0,1.03758,-49.22,-57.3365)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M768.082,555.473C782.037,586.467 784.28,626.107 784.28,635.628C784.28,749.336 691.963,841.653 578.254,841.653C464.546,841.653 372.229,749.336 372.229,635.628C372.229,625.962 371.525,613.953 371.96,603.055C379.966,402.321 518.006,256.498 553.656,226.596C569.203,213.556 562.036,277.984 580.336,335.777C597.615,390.343 617.474,431.949 621.852,420.956C637.961,380.509 664.843,353.262 667.317,369.256C673.318,408.051 703.251,457.98 737.928,504.675C740.656,508.349 743.221,511.971 745.631,515.533C754.52,527.894 762.075,541.278 768.082,555.473Z",
    style: {
      fill: "rgb(254,61,45)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.07952,0,0,1.03758,-49.22,-57.3365)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M694.668,805.592C661.539,828.338 621.439,841.653 578.254,841.653C542.742,841.653 509.317,832.649 480.138,816.801C446.317,766.218 453.649,699.417 456.303,681.781C459.94,657.608 487.009,593.865 496.443,573.645C505.877,553.425 508.856,487.528 511.482,482.272C513.762,477.708 553.712,522.357 573.844,570.479C594.806,620.586 576.841,677.738 595.778,671.515C626.63,661.376 639.475,616.477 643.446,622.719C683.993,686.465 699.864,767.914 694.732,805.161C694.713,805.304 694.691,805.448 694.668,805.592Z",
    style: {
      fill: "rgb(254,192,8)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.07952,0,0,1.03758,-49.22,-57.3365)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M610.125,839.199C599.737,840.815 589.093,841.653 578.254,841.653C558.215,841.653 538.841,838.786 520.518,833.44C480.607,772.835 514.323,667.311 518.985,666.657C523.224,666.063 542.987,689.119 555.465,711.843C570.277,738.818 576.233,766.96 578,768.059C579.787,769.17 589.781,765.481 595.532,754.961C600.254,746.323 607.526,739.281 609.152,741.475C630.712,770.574 614.19,833.023 612.824,835.269C612.641,835.57 611.712,837.043 610.125,839.199Z",
    style: {
      fill: "rgb(254,235,59)"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.d9f0f9a54841f6da57c62e746f202571.svg";
export { ForwardRef as ReactComponent };